module.exports = __webpack_public_path__ + "static/media/SF-Pro.2ea2d54d.ttf";